import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Head from '../../../layout/head/Head';
import Content from '../../../layout/content/Content';
import { Block, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent, Row, RSelect } from '../../../components/Component';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import { RETRIEVE_TENANT_GOODS_RECEIVED_LIST_API } from '../../../api/api_data';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { fail_retrieve_tenant_goods_issued_list, loading_retrieve_tenant_goods_issued_list, reset_retrieve_tenant_goods_issued_list, success_retrieve_tenant_goods_issued_list } from '../../../reducers/auth_tenant/retrieve_tenant_goods_issued_list_slice';
import { addThreeDots, formatToSentenceCase, getSelectedOption, messageToast } from '../../../utils/Utils';
import { COULD_NOT_RETRIEVE_GOODS_ISSUED_LIST_ERROR_MSG, COULD_NOT_RETRIEVE_GOODS_ISSUED_LIST_SUCCESS_MSG } from '../../../utils/error_success_messages';
import * as app_consts from "../../../utils/app_consts";
import { motion } from 'framer-motion';
import DatePicker from 'react-datepicker';
import { Alert, Badge, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import AuthTenantNoData from '../../error/AuthTenantNoData';
import { Link } from 'react-router-dom';
import ViewHistoryDetailsModal from '../../../components/modal/ViewHistoryDetailsModal';
import ViewGoodsIssuedPDFModal from '../../../components/modal/ViewGoodsIssuedPDFModal';

const initialState = { initial_start_date: moment().startOf("month").format("YYYY-MM-DD HH:mm:ss"), initial_end_date: moment().format("YYYY-MM-DD HH:mm:ss"), start_date: moment().startOf("month").format("YYYY-MM-DD HH:mm:ss"), end_date: moment().format("YYYY-MM-DD HH:mm:ss"), warehouse_id: "all" };

const GoodsIssuedManagement = ({ tenant_info, user_info }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState();
  const [form_data, setFormData] = useState(initialState);
  const [selectedRange, setSelectedRange] = useState([
    moment().startOf("month").toDate(),
    moment().toDate(),
  ]);
  const [retrieval_type, setRetrievalType] = useState(0);
  const [retriaval_loading, setRetrievalLoading] = useState(false);
  const [retrievalError, setRetrievalError] = useState("");
  const dispatch = useDispatch();
  const [showPicker, setShowPicker] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sm, updateSm] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [current_page_data, setCurrentPageData] = useState([]);
  const [view_history_modal, setViewHistoryModal] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState([]);
  const [view_history_pdf_modal, setViewHistoryPdfModal] = useState(false);

  useEffect(() => {
    retrieve_data();
  }, []);

  const retrieve_data = () => {
    setError("");
    setRetrievalError("");

    // Get the browser's timezone
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Get the browser's timezone offset in minutes
    const offsetMinutes = new Date().getTimezoneOffset();
    const offsetHours = Math.abs(offsetMinutes) / 60;
    const offsetSign = offsetMinutes > 0 ? "-" : "+";
    const formattedOffset = `${offsetSign}${String(offsetHours).padStart(2, "0")}:00`;
    setLoading(true);
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_goods_issued_list, success_retrieve_tenant_goods_issued_list, fail_retrieve_tenant_goods_issued_list, COULD_NOT_RETRIEVE_GOODS_ISSUED_LIST_ERROR_MSG, COULD_NOT_RETRIEVE_GOODS_ISSUED_LIST_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_GOODS_RECEIVED_LIST_API}/${form_data.start_date}${formattedOffset}/${form_data.end_date}${formattedOffset}/${form_data?.warehouse_id}`));
  };

  const retrieve_tenant_goods_issued_list_listener = useSelector((state) => state.retrieve_tenant_goods_issued_list.retrieve_tenant_goods_issued_list);

  useEffect(() => {
    if (retrieve_tenant_goods_issued_list_listener?.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_goods_issued_list_listener?.status === app_consts.LOADING)
      {
        setError("");
        setRetrievalError("");
        if (retrieval_type === 0)
        {
          setLoading(true);
        }
        else
        {
          setRetrievalLoading(true);
        }
      } else
      {
        if (retrieve_tenant_goods_issued_list_listener?.status === app_consts.FAIL)
        {
          messageToast(retrieve_tenant_goods_issued_list_listener.message, app_consts.FAIL);
          if (retrieval_type === 0)
          {
            setError(retrieve_tenant_goods_issued_list_listener?.message);
          }
          else
          {
            setRetrievalError(retrieve_tenant_goods_issued_list_listener?.message);
          }
        }
        if (retrieve_tenant_goods_issued_list_listener?.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_goods_issued_list_listener?.data);
          setCurrentPageData(retrieve_tenant_goods_issued_list_listener?.data);
        }
        dispatch(reset_retrieve_tenant_goods_issued_list());
        if (retrieval_type === 0)
        {
          setLoading(false);
        }
        else
        {
          setLoading(false);
          setRetrievalType(0);
          setLoading(false);
          setRetrievalLoading(false);
        }
      }
    }
  }, [retrieve_tenant_goods_issued_list_listener, retrieval_type]);

  const handleCustomRange = () => {
    setShowPicker(!showPicker);
  };


  const handleDateChange = (dates) => {
    const [start, end] = dates;

    setSelectedRange([start, end]); // This updates the calendar UI

    if (start && end)
    {
      setFormData({
        ...form_data,
        start_date: moment(start).format("YYYY-MM-DD 00:00:00"),
        end_date: moment(end).format("YYYY-MM-DD 23:59:59"),
      });
    }
  };

  const handleApply = () => {
    if (selectedRange.length === 2)
    {
      setRetrievalType(1);
      retrieve_data();
      setShowPicker(false);
    }
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate the start and end index for the current page
  const startIndex = (currentPage - 1) * itemPerPage;
  const endIndex = startIndex + itemPerPage;
  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.goods_issued?.slice(indexOfFirstItem, indexOfLastItem);

  const open_view_history_modal = (timestamp) => {
    const history_field = page_data?.goods_issued?.find((his) => his?.inventory?.inserted_at === timestamp);
    const restructed_data = { message: history_field?.inventory?.message, timestamp: history_field?.inventory?.inserted_at };
    setSelectedHistory(restructed_data);
    setViewHistoryModal(true);
  };

  const close_view_history_modal = () => {
    setSelectedHistory([]);
    setViewHistoryModal(false);
  };

  const open_view_history_pdf_modal = (item, type) => {
    setSelectedHistory(type === "single" ? [item] : "");
    setViewHistoryPdfModal(true);
  };

  const close_view_history_pdf_modal = () => {
    setSelectedHistory([]);
    setViewHistoryPdfModal(false);
  };

  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Goods Issued` : "Goods Issued"} />
      <Content>
        <BlockHead size="sm">
          <BlockHeadContent>
            <BlockTitle page>Goods Issued</BlockTitle>
          </BlockHeadContent>
          {
            !(loading || error) && (
              <>
                <BlockHeadContent>
                  <div className="toggle-wrap nk-block-tools-toggle">
                    <a
                      href="#more"
                      className="btn btn-icon btn-trigger toggle-expand me-n1"
                      onClick={(ev) => {
                        ev.preventDefault();
                        updateSm(!sm);
                      }}
                    >
                      <Icon name="more-v"></Icon>
                    </a>
                    <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                      <ul className="nk-block-tools g-3">
                        <li>
                          <div className="form-control-wrap">
                            <div className="form-icon form-icon-right">
                              <Icon name="search"></Icon>
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              id="default-04"
                              value={searchTerm}
                              onChange={e => setSearchTerm(e.target.value)}
                              placeholder="Search for Goods Issued"
                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </BlockHeadContent>
              </>
            )
          }
        </BlockHead>
        <Block>


          {
            loading ? (
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Goods Issued..." />
            ) : error ? (
              <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
            ) : (
              <Block style={{ marginTop: '20px' }}>
                <Row className="g-gs" style={{ marginBottom: '20px' }}>

                  <motion.div
                    className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between flex-wrap bg-light p-3 mb-3"
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                  >
                    <div className="mb-2 mb-sm-0">

                      {/* Toggle Button */}
                      <div className="d-flex align-items-center mb-2">
                        <Button color="primary" size="sm" onClick={handleCustomRange}>
                          {showPicker ? "Cancel" : "Custom Range"}
                        </Button>
                      </div>

                      {/* Conditional Date Range Picker */}
                      {showPicker && (
                        <>
                          <motion.div
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="mb-3"
                          >
                            <label className="form-label fw-semibold text-muted mb-1">
                              Select Date Range
                            </label>

                            <DatePicker
                              selected={selectedRange[0]}
                              onChange={handleDateChange}
                              startDate={selectedRange[0]}
                              endDate={selectedRange[1]}
                              selectsRange
                              dateFormat="yyyy-MM-dd"
                              className="form-control"
                            />

                            <label className="form-label fw-semibold text-muted mb-1">
                              Warehouse
                            </label>
                            <div className="w-100">
                              <RSelect
                                options={page_data?.warehouse_data}
                                className="w-100"
                                placeholder="Search"
                                id="warehouse_id"
                                onChange={(e) => {
                                  setFormData({ ...form_data, ["warehouse_id"]: e.value });
                                }}
                                value={getSelectedOption(form_data.warehouse_id, page_data?.warehouse_data)}
                              />
                            </div>
                            <Button
                              color="success"
                              size="sm"
                              className="mt-2"
                              onClick={handleApply}
                              disabled={!form_data?.start_date || !form_data?.end_date || retriaval_loading}
                            >
                              {retriaval_loading ? "Retrieving Data" : "Apply"}
                            </Button>
                          </motion.div>
                        </>
                      )}

                      {retrievalError && (
                        <Alert className="my-4" color="danger">
                          {retrievalError}
                        </Alert>
                      )}
                      {/* Display current date info */}
                      {!showPicker && (
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.3 }}
                        >
                          <motion.div
                            className="bg-light border-start border-primary ps-3 py-2 mb-3 rounded"
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.4, delay: 0.1 }}
                          >
                            <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                              📅 Showing data from{" "}
                              <span className="fw-semibold text-dark">
                                {form_data?.start_date}
                              </span>{" "}
                              up to{" "}
                              <span className="fw-semibold text-dark">
                                {form_data?.end_date}
                              </span>.
                            </p>
                          </motion.div>
                        </motion.div>
                      )}

                    </div>
                  </motion.div>


                  {
                    page_data?.goods_issued && page_data?.goods_issued?.length > 0 ?
                      <>
                        <Block>
                          <div className="nk-tb-list is-separate is-medium mb-3">
                            <DataTableHead className="nk-tb-item">
                              <DataTableRow>
                                <span className="sub-text">Warehouse</span>
                              </DataTableRow>
                              <DataTableRow size="md">
                                <span className="sub-text">Message</span>
                              </DataTableRow>
                              <DataTableRow size="mb">
                                <span className="sub-text">Size / Color</span>
                              </DataTableRow>
                              <DataTableRow size="lg">
                                <span className="sub-text">Units Issued</span>
                              </DataTableRow>
                              <DataTableRow size="lg">
                                <span className="sub-text">Date</span>
                              </DataTableRow>
                              <DataTableRow size="lg">
                                <span className="sub-text">Action</span>
                              </DataTableRow>
                            </DataTableHead>
                            {/*Head* */}
                            {currentItems.length > 0
                              ? currentItems.map((item) => (
                                <DataTableItem key={item.id}>
                                  <DataTableRow>
                                    <Link to="#" /* onClick={(e) => { e.preventDefault(); open_view_goods_received_details_modal(item?.goods_received_ref_no); }} */>
                                      <div className="user-card">
                                        <div className="user-info">
                                          <span className="tb-lead">
                                            {item?.warehouse_site?.name || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                          </span>
                                          <span>
                                            <Badge
                                              color={
                                                item?.warehouse_site?.status === app_consts.ACTIVE
                                                  ? "success"
                                                  : "warning"
                                              }
                                              className="badge-dot"
                                            >
                                              {item?.warehouse_site?.status ? formatToSentenceCase(item?.warehouse_site?.status)?.toUpperCase() : "--"}
                                            </Badge>
                                          </span>
                                        </div>
                                      </div>
                                    </Link>
                                  </DataTableRow>
                                  <DataTableRow>
                                    <span>{item?.inventory?.inventory_audit?.message ? addThreeDots(item?.inventory?.inventory_audit?.message, 30) : "--"}</span>
                                  </DataTableRow>
                                  <DataTableRow>
                                    <div className="user-card">
                                      <div className="user-info">
                                        <span className="tb-lead">
                                          {item?.inventory?.packet_size || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                        </span>
                                        <span>
                                          {item?.inventory?.color || "--"}
                                        </span>
                                      </div>
                                    </div>
                                  </DataTableRow>
                                  <DataTableRow size="mb">
                                    <span className="tb-sub">{item?.inventory?.units || "0"}</span>
                                  </DataTableRow>
                                  <DataTableRow size="md">
                                    <span className="tb-odr-date">{item?.inventory?.inserted_at ? moment(item?.inventory?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                  </DataTableRow>
                                  <DataTableRow>
                                    <UncontrolledDropdown>
                                      <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                                        <Icon name="more-h"></Icon>
                                      </DropdownToggle>
                                      <DropdownMenu end>
                                        <ul className="link-list-opt no-bdr">
                                          <li>
                                            <Link
                                              onClick={(e) => {
                                                e.preventDefault();
                                                open_view_history_modal(item?.inventory?.inserted_at);
                                              }}
                                            >
                                              <Icon name="focus"></Icon>
                                              <span>View Details</span>
                                            </Link>
                                          </li>

                                          <li>
                                            <Link
                                              onClick={(e) => {
                                                e.preventDefault();
                                                open_view_history_pdf_modal(item, "single");
                                              }}
                                            >
                                              <Icon name="focus"></Icon>
                                              <span>View PDF</span>
                                            </Link>
                                          </li>
                                        </ul>
                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                                  </DataTableRow>
                                </DataTableItem>
                              ))
                              : null}
                          </div>
                          {currentItems?.length > 0 && (
                            <div className="mt-3">
                              <PaginationComponent
                                itemPerPage={itemPerPage}
                                totalItems={current_page_data?.length}
                                paginate={paginate}
                                currentPage={currentPage}
                              />
                            </div>
                          )}
                        </Block>
                        <ViewHistoryDetailsModal isOpen={view_history_modal} closeModal={close_view_history_modal} data={selectedHistory} title="Goods Issued History Details" />

                        <ViewGoodsIssuedPDFModal isOpen={view_history_pdf_modal} closeModal={close_view_history_pdf_modal} data={selectedHistory} title="Goods Issued PDF" tenant_info={tenant_info} />
                      </>
                      :
                      <>
                        <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Goods Issued Found"} />
                      </>
                  }

                </Row>
              </Block>
            )
          }
        </Block>
      </Content>
    </>
  );
};

export default GoodsIssuedManagement;